import {
    FETCH_15MIN_REQUESTED,
    FETCH_15MIN_SUCCEEDED,
    FETCH_15MIN_FAILED,
    FETCH_1HOUR_REQUESTED,
    FETCH_1HOUR_SUCCEEDED,
    FETCH_1HOUR_FAILED,
    FETCH_6HOUR_REQUESTED,
    FETCH_6HOUR_SUCCEEDED,
    FETCH_6HOUR_FAILED,
} from './constants';

const initialState = {
    data15Min: null,
    data15MinError: null,
    fetching15Min: false,
    data15MinInterval: 10000, //interval in miliseconds to request
    startDate15Min: '',
    endDate15Min: '',

    data1Hour: null,
    data1HourError: null,
    fetching1Hour: false,
    data1HourInterval: 30000, //interval in miliseconds to request
    startDate1Hour: '',
    endDate1Hour: '',

    data6Hour: null,
    data6HourError: null,
    fetching6Hour: false,
    data6HourInterval: 60000, //interval in miliseconds to request
    startDate6Hour: '',
    endDate6Hour: '',
};

export default function(state = initialState, action) {
    switch (action.type) {
        case FETCH_15MIN_REQUESTED:
            return {
                ...state,
                fetching15Min: true,
                startDate15Min: action.startDate,
                endDate15Min: action.endDate,
            };
        case FETCH_15MIN_SUCCEEDED:
            return {
                ...state,
                fetching15Min: false,
                data15Min: action.data,
            };
        case FETCH_15MIN_FAILED:
            return {
                ...state,
                fetching15Min: false,
                data15MinError: action.error,
            };

        case FETCH_1HOUR_REQUESTED:
            return {
                ...state,
                fetching1Hour: true,
                startDate1Hour: action.startDate,
                endDate1Hour: action.endDate,
            };
        case FETCH_1HOUR_SUCCEEDED:
            return {
                ...state,
                fetching1Hour: false,
                data1Hour: action.data,
            };
        case FETCH_1HOUR_FAILED:
            return {
                ...state,
                fetching1Hour: false,
                data1HourError: action.error,
            };
        case FETCH_6HOUR_REQUESTED:
            return {
                ...state,
                fetching6Hour: true,
                startDate6Hour: action.startDate,
                endDate6Hour: action.endDate,
            };
        case FETCH_6HOUR_SUCCEEDED:
            return {
                ...state,
                fetching6Hour: false,
                data6Hour: action.data,
            };
        case FETCH_6HOUR_FAILED:
            return {
                ...state,
                fetching6Hour: false,
                data6HourError: action.error,
            };
        default:
            return state;
    }
}
